import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { Parse } from "parse";
import Step1 from "./step1.js";
import Step2 from "./step2.js";
import Step2Pro from "./step2pro.js";
import MainHeader from "../Header/header";
import MyFooter from "../Footer/footer";

//Action Creators
import { onChangeChecked, submitForm } from "../Actions/profileActionCreators";
import "../style.less";

//Img
//import LmIcon from "../img/logoRondNoirPng.png"

// antd components
import { Col, Steps, Layout } from "antd";
const Step = Steps.Step;

const { Content } = Layout;

const Contentstyled = styled(Content)`
  background: white !important;
`;

class WizardForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      professional: false
    };
    this.next1 = this.next1.bind(this);
    //this.next1Pro = this.next1Pro.bind(this)
    this.next2 = this.next2.bind(this);
    this.prev = this.prev.bind(this);
    this.chooseSteps = this.chooseSteps.bind(this);
  }

  next1() {
    var ctx = this;
    const current = ctx.state.current + 1;
    this.setState({ current });
  }

  next2() {
    const current = this.state.current + 1;
    this.setState({ current });
  }

  prev() {
    const current = this.state.current - 1;
    this.setState({ current });
  }

  chooseSteps = e => {
    if (e !== undefined) {
      this.setState({ professional: e });
    }
    const welcome = {
      title: "Bienvenue !",
      content: <Step2 next2={this.next2} prev={this.prev} />
    };
    const pro = {
      title: "Pour les pros",
      content: <Step2Pro next2={this.next2} prev={this.prev} />
    };

    const stepsNormal = [
      {
        title: "Vos informations",
        content: <Step1 next1={this.next1} chooseSteps={this.chooseSteps} />
      },
      welcome
    ];

    const stepsPro = [
      {
        title: "Vos informations",
        content: <Step1 next1={this.next1} chooseSteps={this.chooseSteps} />
      },
      pro,
      welcome
    ];
    let wizard = this.state.professional !== true ? stepsNormal : stepsPro;
    return wizard;
  };

  render() {
    const { current } = this.state;
    return (
      <Layout style={{ minHeight: "100vh" }}>
        <MainHeader />
        <Contentstyled>
          <Col
            style={{
              marginLeft: "10px",
              marginTop: "10px",
              marginRight: "10px"
            }}
          >
            <Steps current={current}>
              {this.chooseSteps().map(item => (
                <Step key={item.title} title={item.title} />
              ))}
            </Steps>
          </Col>
          <div
            className="steps-content"
            style={{ marginLeft: 10, marginTop: 20, marginRight: 10 }}
          >
            {this.chooseSteps()[this.state.current].content}
          </div>
        </Contentstyled>
        <MyFooter />
      </Layout>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    submitForm: values => {
      dispatch(submitForm(values));
      saveParseUser(values);
    },
    onHideAge: e => {
      dispatch(onChangeChecked(e));
    }
  };
};

function saveParseUser(values) {
  // The user was retrieved successfully.

  var currentUser = Parse.User.current();
  var sessionToken = currentUser.getSessionToken();
  Parse.User.become(sessionToken).then(function(user) {
    user.set("firstName", values.firstName);
    user.set("lastName", values.lastName);
    user.set("name", values.nickName);
    user.set("gender", values.gender);
    user.set("birthDate", values.birthDate._d);
    user.set("height", values.height);
    user.set("weight", values.weight);
    user.set("adresse", values.adresse);
    user.set("professional", values.professional);
    user.set("level", values.level);
    user.set("speed", values.speed);
    user.set("email", values.email);
    user.set("phone", values.phone);
    user.set("availabilities", values.availabilities);
    user.set("description", values.description);

    user.save(null, {
      success: function(user) {
        // Execute any logic that should take place after the object is saved.
        // à modifier : mettre ici l'appel a mapDispatchToProps quand la sauvegarde s'est effectuée
      },

      error: function(user, error) {
        // Execute any logic that should take place if the save fails.
        // error is a Parse.Error with an error code and message.
      }
    });
  });
}

const mapStateToProps = globalReducers => globalReducers;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WizardForm);
